<template>
  <v-card class="pa-3">
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-4">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full"> معاینه سر تا پا </span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="injuryModal" width="500" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-medical-bag</v-icon>
              <span class="modal-title-text mr-2">علائم</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="injury-list-part">
          <v-row>
            <v-col cols="12" v-for="item in injuryTypeList" :key="item.id" class="mb-n12">
              <v-checkbox @change="selectedItemsChange()" :label="item.title" :value="item.title"
                v-model="selectedProblems"></v-checkbox>
            </v-col>
            <v-col cols="12" v-if="burnFlag" class="mt-3">
              <v-text-field label="درجه سوختگی" outlined prepend-inner-icon="mdi-text mdi-18px" clearable
                clear-icon="mdi-close-circle mdi-18px" v-model="burnDegree" @keypress="isNumber($event)"
                dense></v-text-field>
            </v-col>
            <v-col cols="12" v-if="otherFlag" class="mt-3">
              <v-text-field label="سایر با ذکر نام" outlined prepend-inner-icon="mdi-text mdi-18px" clearable
                clear-icon="mdi-close-circle mdi-18px" v-model="otherText" dense></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addProblem()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddProblem()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="ma-0 overflow-y-auto">
      <v-col cols="6">
        <v-row>
          <v-col cols="12" class="problem-part">
            <v-row>
              <v-col cols="12" v-for="item in allProblems" :key="item.id">
                <v-card elevation="0" class="">
                  <v-card-text>
                    <v-row>
                      <v-col class="data-part">
                        <v-row>
                          <span class="mt-3 mb-3 mr-2 data-title">{{ item.bodyPartId }}-</span>
                          <span class="mt-3 data-title">{{ item.isFront }}:</span>
                          <span class="mt-3 mr-3">{{ item.typeOfInjury }}</span>
                          <span class="mr-5 mt-3 data-title" v-if="item.typeOfInjury == 'سوختگی'">
                            درجه:
                          </span>
                          <span class="mr-1 mt-3" v-if="item.typeOfInjury == 'سوختگی'">
                            {{ item.burnDegree }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col class="delete-action-part text-center">
                        <v-row>
                          <v-spacer></v-spacer>
                          <v-icon color="white" class="mt-3 mb-3"
                            @click="deletePatientBodyExaminationFunction(item.id)">
                            mdi-delete mdi-18px
                          </v-icon>
                          <v-spacer></v-spacer>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <human-front-component class="human-front" :hasClick="true" @frontPartClick="frontBodyclick"
          ref="front"></human-front-component>
        <v-spacer></v-spacer>
        <human-back-component class="human-back" :hasBackClick="true" @backPartClick="backBodyclick"
          ref="back"></human-back-component>
      </v-col>
    </v-row>
    <v-row class="ma-0 mt-2">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="nextDialog()">بعدی (اقدامات درمانی)</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">بستن</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import HumanBackComponent from '../../HumanBackComponent.vue';
import HumanFrontComponent from '../../HumanFrontComponent.vue';

import FollowUpPatientStep10Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep10Helper.js';
import PatientBodyExaminationMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientBodyExaminationMixin.js';
import ShearedMixin from '@/Mixins/Shared.js';
import SharedHelper from '@/Helpers/Shared';
export default {
  components: {
    HumanBackComponent,
    HumanFrontComponent,
  },
  mixins: [FollowUpPatientStep10Helper, PatientBodyExaminationMixin, ShearedMixin, SharedHelper],
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    missionType: {
      type: String,
      require: true,
      default: '',
    },
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getAllPatientBodyExaminationFunction(this.patientId);
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      this.$emit('goToNextDialog');
    }
  },
};
</script>
<style scoped>
.txtStyle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 16px;
  color: white;
  background-color: var(--dark-color);
  border-radius: 4px;
}

.human-front {
  position: relative;
}

.human-back {
  position: relative;
  margin-left: 11vh;
}

.injury-list-part {
  height: 70vh;
  overflow-y: auto;
}

.data-part {
  width: 94%;
  min-width: 94%;
  max-width: 94%;
  background: var(--background-color) !important;
  border-top-right-radius: 7px !important;
  border-bottom-right-radius: 7px !important;
}

.delete-action-part {
  width: 6%;
  min-width: 6%;
  max-width: 6%;
  background: var(--dark-color) !important;
  border-top-left-radius: 7px !important;
  border-bottom-left-radius: 7px !important;
}

.data-title {
  color: #000000;
  font-weight: 600;
}

.problem-part {
  height: 70vh;
  overflow-y: auto;
}
</style>
